import React, { useState } from "react";
import styles from "../faq/faq.module.css"; // assuming you have styles here
import { CollapsedIcon, Pluse } from "../../../Svg";
import CustomSeparator from "../../components/maincomps/breadcrumbs/Breadcrumbs";
import breadcrumbStyle from "../../components/maincomps/breadcrumbs/breadcrumbs.module.css"

const faqData = {
    "Topic 1": [
        {
            question: "What are the International Shipping Destinations covered?",
            answer:
                "Singapore | Thailand | UAE | Bahrain | Hong Kong | Kuwait | Malaysia | China | Japan | Korea | Macau | Taiwan | Canada | USA | Belgium | Denmark | France | Germany | Italy | Liechtenstein | Spain | Netherland | Switzerland | UK | Australia | Russia | South Africa | Finland",
        },
        {
            question: "In which currency should the payment be made for international orders?",
            answer:
                "Payments must be made in the local currency of the destination country. For example, shipments to USA, payments must be made in USD.",
            a: "For shipments to UK, payments must be made in GBP.",
        },
        {
            question: "Which mode of payment is available for international orders?",
            answer:
                "Payments must be made through bank wire transfer. Please note that credit or debit cards issued in India will not be accepted for international orders. For further assistance with international orders,",
            a: "kindly contact or WhatsApp us at  +91 9632429387.",
        },
        // {
        //     question: " Who is the Shipping Partner?",
        //     answer: "Our International shipping partner is FedEx.",
        // },
        {
            question: "In How many days I will receive my International order?",
            answer:
                "You will receive your order within 2-3 weeks after the confirmation of the order. The tracking number and link of the shipment will be sent to you once the product is dispatched from our office. Our logistic partner will get in touch with you once your product reaches your destination.",
        },
        {
            question: "What are the Shipping Charges? ",
            answer:
                "There are no Shipping Charges, it's completely Free. Any other import/custom duties or charges levied in the destination country of the shipment has to be borne by the customer as per the actual. These taxes and duties are subject to change.",
        },
        {
            question: "What documents are to be submitted for International shipping?",
            answer:
                "For International Orders you will be required to send us government-issued photo Identity proof preferably:",
            a: " a) Driving License",
            b: "b) SSN, EIN etc.",
            Note: "Indian issued Identity proof will not be accepted for international orders.",
        },
        {
            question: "Are returns or exchanges accepted?",
            answer:
                "Currently, we do not accept any returns or exchanges of our products in case of International Orders.",
        },
    ],

};

const InternationalPolicy = () => {
    const [selectedTopic, setSelectedTopic] = useState("Topic 1");
    const [expandedIndex, setExpandedIndex] = useState(null);

    const handleTopicClick = (topic) => {
        setSelectedTopic(topic);
        setExpandedIndex(null);
    };

    const handleToggle = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <>
            <div className={breadcrumbStyle.breadcrumbStyle}>
                <CustomSeparator home="Home" type="International Shipping" />
            </div>

            <div className={styles.container}>

                <h2>International Shipping</h2>

                <div className={styles.content}>
                    {faqData[selectedTopic].map((item, index) => (
                        <div key={index} className={styles.faqItem}>
                            <div className={styles.question} onClick={() => handleToggle(index)}>
                                {item.question}
                                <span>{expandedIndex === index ? <div><CollapsedIcon /></div> : <div className={styles.positive}><Pluse /></div>}</span>
                            </div>
                            {expandedIndex === index &&
                                <div className={styles.answer}>{item.answer}
                                    {item?.a && (<div>{item?.a}</div>)}
                                    {item?.b && (<div>{item?.b}</div>)}
                                    {item?.Note && (<div>NOTE: {item?.Note}</div>)}
                                </div>
                            }
                        </div>
                    ))}
                </div>

                <div className={styles.mobile_contant}>
                    {Object.keys(faqData).map((topic) => (
                        <div className={styles.content1}>
                            {faqData[topic].map((item, index) => (
                                <div key={index} className={styles.faqItem}>
                                    <div
                                        className={styles.question}
                                        onClick={() => handleToggle(index)}
                                    >
                                        {item.question}
                                        <span>
                                            {expandedIndex === index ? (
                                                <div className={styles.nagative}>-</div>
                                            ) : (
                                                <div className={styles.positive}>+</div>
                                            )}
                                        </span>
                                    </div>
                                    {expandedIndex === index && (
                                        <div className={styles.answer}>{item.answer}
                                            <br />
                                            {item?.a && (<div>{item?.a}</div>)}
                                            {item?.b && (<div>{item?.b}</div>)}
                                            {item?.Note && (<div>NOTE: {item?.Note}</div>)}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default InternationalPolicy;
